import { ArrowUpRight, Mail, MessageCircle } from "lucide-react";
import { EMAIL, LOGO, SITE, WHATSAPP } from "@/lib/brand";

export const CtaBanner = ({ name }) => (
  <section data-testid="cta-banner" className="no-print px-6 md:px-12 py-16">
    <div className="relative grain overflow-hidden bg-[var(--green)] text-[var(--cream)] rounded-[36px] p-8 md:p-14 grid md:grid-cols-12 gap-8 items-center">
      <div className="md:col-span-8 relative z-10">
        <p className="text-xs uppercase tracking-[0.3em] text-[var(--gold)] mb-4">Level up{name ? `, ${name}` : ""}</p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight">
          This calendar is the warm-up.<br />
          <em className="font-serif-cc font-normal text-[var(--gold)]">We play the full game.</em>
        </h2>
        <p className="mt-5 text-base md:text-lg text-[var(--cream)]/80 max-w-xl">
          For better strategies, scroll-stopping shoots and done-for-you execution — get in touch with Catalyst Crew.
          100+ brands already trust the crew.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <a href={WHATSAPP} target="_blank" rel="noreferrer" data-testid="cta-whatsapp-btn"
            className="rounded-full bg-[var(--gold)] text-[var(--green)] px-7 py-3.5 font-bold flex items-center gap-2 hover:scale-[1.04] transition-transform">
            <MessageCircle size={18} /> WhatsApp the crew
          </a>
          <a href={EMAIL} data-testid="cta-email-btn"
            className="rounded-full border border-[var(--cream)]/40 px-7 py-3.5 font-semibold flex items-center gap-2 hover:bg-white/10 transition-colors">
            <Mail size={18} /> contact@catalystcrew.in
          </a>
          <a href={SITE} target="_blank" rel="noreferrer" data-testid="cta-site-btn"
            className="rounded-full px-5 py-3.5 font-semibold flex items-center gap-1 hover:underline underline-offset-4">
            See our work <ArrowUpRight size={18} />
          </a>
        </div>
      </div>
      <div className="md:col-span-4 flex justify-center relative z-10">
        <img src={LOGO} alt="Catalyst Crew logo" className="w-48 md:w-60 floaty" />
      </div>
    </div>
  </section>
);
